import React, { useEffect, useState } from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity, Dimensions } from 'react-native';
import Typography from '../../typography/Typography';
import { ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { interestHeading } from './Data';
import Icon from '../../icon/Icon';
import TooltipComp from '../TooltipComp';
import { addCommasToNumber, showPlj, showShareLink } from '../utils';
const InterestTable = ({ activeTab, tabData, customerData, navigateToCustomerDetails, navigateToCustomerJourney, navigateToShareLink, currentPageCustomer, totalNoOfPages, actualPageSizeCustomer, navigateToInterestScreen, triggerAction, filterObj, searchText, filterSelected, numberOfFilterApplied, }) => {
    const [showchargesDueContent, setShowChargesDueContent] = useState(false);
    const [sortOrder, setSortOrder] = useState({});
    const [sortedCustomerData, setSortedCustomerData] = useState(customerData || []);
    const [showJourney, setShowJourney] = useState(showPlj());
    const [showLink, setShowLink] = useState(showShareLink());
    const cellFlexValues = [3, 2, 3, 2, 3, 2, 2, 3.5, 3.5];
    const cellWidthValues = [125, 125, 100, 125, 150, 125, 125, 125, 150];
    const BoxWidth = 1150;
    const screenWidth = Dimensions.get('window').width;
    useEffect(() => {
        setSortedCustomerData(customerData);
    }, [customerData]);
    const handleSort = (key) => {
        setShowChargesDueContent(false);
        if (key === 'chargedDue') {
            setShowChargesDueContent(!showchargesDueContent);
            return;
        }
        let newSortOrder = sortOrder[key] === 'asc' ? 'desc' : 'asc';
        const sortedData = [...customerData].sort((a, b) => {
            if (a[key] < b[key])
                return newSortOrder === 'asc' ? -1 : 1;
            if (a[key] > b[key])
                return newSortOrder === 'asc' ? 1 : -1;
            return 0;
        });
        setSortedCustomerData(sortedData);
        setSortOrder({ [key]: newSortOrder });
    };
    const renderHeader = () => (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row' }, onPress: () => { setShowChargesDueContent(false); } }, Object.keys(interestHeading[0]).map((key, index) => (React.createElement(View, { key: key, style: { backgroundColor: '#F3F5FC', padding: 8, borderTopWidth: 1, borderLeftWidth: 1, borderRightWidth: key === 'action' ? 1 : 0, borderTopLeftRadius: key === 'fullName' ? 8 : 0, borderTopRightRadius: key === 'action' ? 8 : 0, borderColor: '#E4E7EC', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: cellWidthValues[index] } },
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: interestHeading[0][key], color: ColorTokens.Grey_Charcoal }),
        React.createElement(TouchableOpacity, { onPress: () => { handleSort(key); } },
            React.createElement(Icon, { name: key === 'action' ? undefined : key === 'chargedDue' ? IconTokens.Info : IconTokens.SYSTEM_SORT_DLS, size: IconSizeTokens.MD, color: ColorTokens.Grey_Charcoal }),
            showchargesDueContent && key === 'chargedDue' &&
                React.createElement(View, { style: { zIndex: 999 } },
                    React.createElement(TooltipComp, { title: "Any outstanding charges on your loan account will be deducted from the mandate. For more details about the pending charges, please refer to your Statement of Account (SOA)", leftShiftContent: -200, fontSize: FontSizeTokens.XS, textColor: ColorTokens.Grey_Night, tooltipContainerBottomPosition: 36, tooltipArrowBottomPosition: 28, bgColor: ColorTokens.Black_20, width: 560 }))))))));
    const renderRow = (data, index, dataLength) => {
        return (React.createElement(TouchableOpacity, { key: index, style: { flexDirection: 'row' }, activeOpacity: 1, onPress: () => { setShowChargesDueContent(false); } }, Object.keys(interestHeading[0]).map((key, id) => (React.createElement(View, { key: key, style: { padding: 8, borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: index === dataLength - 1 ? 1 : 0, borderRightWidth: key === 'action' ? 1 : 0, borderBottomLeftRadius: (key === 'fullName' && index === dataLength - 1) ? 8 : 0, borderBottomRightRadius: (key === 'action' && index === dataLength - 1) ? 8 : 0, borderColor: '#E4E7EC', width: cellWidthValues[id] } },
            (key !== 'action' && key !== 'mandateStatus') &&
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0R, label: (key === 'totalDue' || key === 'chargedDue' || key === 'interestDue') ? `₹${addCommasToNumber(data[key])}` : key === 'phoneNumber' ? `${data[key].substr(3)}` : key === 'interestRate' ? `${data[key]}%` : String(data[key]), color: ColorTokens.Grey_Charcoal }),
            key === 'mandateStatus' &&
                React.createElement(View, null,
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: data[key], color: ColorTokens.Grey_Charcoal }),
                    React.createElement(View, { style: { marginTop: 4 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: data[key] === 'Registered' ? `Auto-debit on ${data?.mandateDate}` : 'Pay manually', color: ColorTokens.Grey_Charcoal }))),
            key === 'action' &&
                React.createElement(View, null,
                    React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: async () => {
                            {
                                await triggerAction({
                                    ...navigateToCustomerDetails,
                                    payload: {
                                        currentActiveTabIndex: 1,
                                        customerViewData: data,
                                        numberOfFilterApplied,
                                        filterObj,
                                        currentPageCustomer,
                                        ...navigateToCustomerDetails.payload,
                                    }
                                });
                            }
                        } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'View details', color: ColorTokens.Primary_100 }),
                        React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 })),
                    showJourney &&
                        React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: async () => {
                                if (navigateToCustomerJourney)
                                    await triggerAction({
                                        ...navigateToCustomerJourney,
                                        payload: {
                                            borrowerAccountId: data['accountId'],
                                            name: data['fullName'],
                                            ...navigateToCustomerJourney.payload
                                        }
                                    });
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'View as client', color: ColorTokens.Primary_100 }),
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 })),
                    showLink &&
                        React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: async () => {
                                await triggerAction({
                                    ...navigateToShareLink,
                                    payload: {
                                        currentActiveTabIndex: 1,
                                        customerViewData: data,
                                        numberOfFilterApplied,
                                        filterObj,
                                        currentPageCustomer,
                                        ...navigateToShareLink.payload,
                                    }
                                });
                            } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Share with client', color: ColorTokens.Primary_100 }),
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XL, color: ColorTokens.Primary_100 }))))))));
    };
    return (React.createElement(View, null,
        React.createElement(ScrollView, { horizontal: true },
            React.createElement(View, { style: styles.container },
                React.createElement(View, { style: { marginBottom: 24 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `Showing ${actualPageSizeCustomer} ${actualPageSizeCustomer > 1 ? 'customers' : 'customer'} `, color: currentPageCustomer > 1 ? ColorTokens.Primary_100 : ColorTokens.Grey_Night })),
                interestHeading.length > 0 && renderHeader(),
                sortedCustomerData && sortedCustomerData.map((data, index) => renderRow(data, index, sortedCustomerData?.length)))),
        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 72, paddingRight: screenWidth >= 1600 ? ((1600 - BoxWidth - 290)) : BoxWidth > screenWidth - 290 ? 10 : screenWidth - 290 - BoxWidth } },
            React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: async () => {
                    if (navigateToInterestScreen && currentPageCustomer > 1) {
                        let currentPage = currentPageCustomer > 0 && currentPageCustomer - 1;
                        await triggerAction({
                            ...navigateToInterestScreen,
                            payload: {
                                currentPage,
                                searchText,
                                renderFilterSelected: filterSelected ? filterObj : {},
                                ...navigateToInterestScreen.payload
                            }
                        });
                    }
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_LEFT_DLS, size: IconSizeTokens.LG, color: currentPageCustomer > 1 ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3S, label: 'Previous', color: currentPageCustomer > 1 ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { flexDirection: 'row' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3S, label: `Page ${currentPageCustomer} of ${totalNoOfPages}`, color: ColorTokens.Grey_Charcoal })),
            React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: async () => {
                    const isDataAvailable = currentPageCustomer < totalNoOfPages;
                    if (navigateToInterestScreen && isDataAvailable) {
                        let currentPage = currentPageCustomer + 1;
                        await triggerAction({
                            ...navigateToInterestScreen,
                            payload: {
                                currentPage,
                                searchText,
                                renderFilterSelected: filterSelected ? filterObj : {},
                                ...navigateToInterestScreen.payload
                            }
                        });
                    }
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3S, label: 'Next', color: currentPageCustomer < totalNoOfPages ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal }),
                React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.LG, color: currentPageCustomer < totalNoOfPages ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal })))));
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingRight: 16,
        paddingVertical: 16
    },
    row: {
        flexDirection: 'row',
    },
    modalBackground: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
export default InterestTable;
